import { styled, Typography, useTheme } from '@mui/material';

const TitleProfileText = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.h1.fontWeight,
  color: theme.palette.primary.main,
  fontSize: theme.typography.h3.fontSize,
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.availableBalance.fontSize,
  },
}));

export const TitleProfile = ({ text }) => {
  const theme = useTheme();
  return <TitleProfileText>{text}</TitleProfileText>;
};
